import React from 'react';

import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { createPortal } from 'react-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { selectSnackbarDetails } from 'selectors/snackbar';

export default function SnackbarContainer() {
  const snackbar = useSelector(selectSnackbarDetails, shallowEqual);
  const { vertical, horizontal } = snackbar;
  return createPortal(
    <Snackbar anchorOrigin={{ vertical, horizontal }} open={snackbar.display}>
      <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
    </Snackbar>,
    document.body
  );
}
